import { Drawer } from '@mui/material';
import { observer } from 'mobx-react-lite';
import styles from './index.module.scss';
import { useClinicalEventsModal } from '../../../ClinicalEvents/Drawer/Provider';
import DrawerContent from '../../../ClinicalEvents/Drawer/DrawerContent';
import eventDrawerStyles from '../../../ClinicalEvents/Drawer/index.module.scss';
import classNames from 'classnames';
import EventDetailsContent from './EventDetailsContent';
import eventStyles from '../../../ClinicalEvents/index.module.scss';
import useIsPrimaryTheme from '../../../../../hooks/useIsPrimaryTheme';

const MobileClinicalEventModal = ({
  onChange,
  uuid,
}: {
  onChange: (uuid: string) => void;
  uuid?: string;
}) => {
  const {
    contextData: { clinicalEventUuid, isNewItem },
  } = useClinicalEventsModal();
  const isEventAction = !!clinicalEventUuid || !!isNewItem;
  const isOpenDrawer = isEventAction || !!uuid;
  const isPrimaryTheme = useIsPrimaryTheme();

  return (
    <Drawer
      className={classNames(
        eventDrawerStyles.eventModal,
        styles.eventModal,
        eventStyles.root,
        {
          [classNames(
            eventStyles.primaryP3Main,
            eventDrawerStyles.primaryP3Main
          )]: isPrimaryTheme,
        }
      )}
      classes={{ paper: styles.paper }}
      anchor={'right'}
      open={isOpenDrawer}>
      {isOpenDrawer ? (
        uuid && !isEventAction ? (
          <EventDetailsContent uuid={uuid} onChange={onChange} />
        ) : (
          <DrawerContent />
        )
      ) : null}
    </Drawer>
  );
};

export default observer(MobileClinicalEventModal);
